import React, { useState } from 'react';
import { BrowserRouter as Router, Route, Routes, Link, useLocation } from 'react-router-dom';
import Home from './components/Home';
import AboutMe from './components/AboutMe';
import Services from './components/Services';
import Projects from './components/Projects';
import Contact from './components/Contact';
import BlogResources from './components/BlogResources';
import BlogPost from './components/BlogPost';
import styles from './App.module.css';

const NavLink = ({ to, children }) => {
  const location = useLocation();
  const isActive = location.pathname === to;
  
  const handleClick = () => {
    window.scrollTo({
      top: 0,
      behavior: 'smooth'
    });
  };
  
  return (
    <Link 
      to={to} 
      className={`${styles.navLink} ${isActive ? styles.activeLink : ''}`}
      onClick={handleClick}
    >
      {children}
    </Link>
  );
};

const Navigation = ({ isOpen, toggleMenu }) => {
  return (
    <nav className={`${styles.nav} ${isOpen ? styles.navOpen : ''}`}>
      <NavLink to="/">Home</NavLink>
      <NavLink to="/about">About Me</NavLink>
      <NavLink to="/services">Services</NavLink>
      <NavLink to="/projects">Projects</NavLink>
      <NavLink to="/contact">Contact</NavLink>
      <NavLink to="/blog-resources">Blog/Resources</NavLink>
    </nav>
  );
};

const App = () => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);

  const toggleMenu = () => {
    setIsMenuOpen(!isMenuOpen);
  };

  const closeMenu = () => {
    if (isMenuOpen) {
      setIsMenuOpen(false);
    }
  };

  const scrollToTop = () => {
    window.scrollTo({
      top: 0,
      behavior: 'smooth'
    });
  };

  const handleFooterLinkClick = () => {
    scrollToTop();
    closeMenu();
  };

  return (
    <Router>
      <div className={styles.app}>
        <header className={styles.header}>
          <div className={styles.logo}>
            <span className={styles.logoText}>Emmanuel&nbsp;Oben</span>
            <span className={styles.logoSubtext}>Cybersecurity Systems Engineer</span>
          </div>
          <button 
            className={`${styles.menuButton} ${isMenuOpen ? styles.menuOpen : ''}`}
            onClick={toggleMenu}
            aria-label="Toggle menu"
          >
            <span></span>
            <span></span>
            <span></span>
          </button>
          <Navigation isOpen={isMenuOpen} toggleMenu={toggleMenu} />
        </header>

        <main className={styles.main} onClick={closeMenu}>
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/about" element={<AboutMe />} />
            <Route path="/services" element={<Services />} />
            <Route path="/projects" element={<Projects />} />
            <Route path="/contact" element={<Contact />} />
            <Route path="/blog-resources" element={<BlogResources />} />
            <Route path="/blog/:slug" element={<BlogPost />} />
          </Routes>
        </main>

        <footer className={styles.footer}>
          <div className={styles.footerContent}>
            <div className={styles.footerSection}>
              <h3>Emmanuel Cybersecurity</h3>
              <p>Securing your digital future</p>
            </div>
            <div className={styles.footerSection}>
              <h3>Quick Links</h3>
              <Link to="/services" onClick={handleFooterLinkClick}>Services</Link>
              <Link to="/contact" onClick={handleFooterLinkClick}>Contact</Link>
              <Link to="/blog-resources" onClick={handleFooterLinkClick}>Resources</Link>
            </div>
            <div className={styles.footerSection}>
              <h3>Contact</h3>
              <p>Email: obentech@gmail.com</p>
              <p>WhatsApp: +2348139189213</p>
            </div>
          </div>
          <div className={styles.footerBottom}>
            <p>&copy; {new Date().getFullYear()} emmaoben.com. All rights reserved.</p>
          </div>
        </footer>
      </div>
    </Router>
  );
};

export default App;
